import { useState, useEffect } from 'react';
import { debounce } from '@utils/helpers';

export interface WindowSize {
  width: number;
  height: number;
}

/**
 * Hook to track window size changes with debounced updates
 */
export const useWindowSize = (debounceMs: number = 100): WindowSize => {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = debounce(() => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }, debounceMs);

    window.addEventListener('resize', handleResize);

    // Call handler immediately to ensure we have current size
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, [debounceMs]);

  return windowSize;
};
